<div
  class="relative h-28 w-28"
  [ngClass]="[styleClass]">
  @if (value) {
    <div
      class="border-line-default bg-bg-surface-low h-full w-full overflow-hidden rounded-lg border"
      [class]="boxStyleClass">
      <button
        type="button"
        class="bg-bg-surface-default h-full w-full"
        (click)="preview.emit(value)">
        <img
          #Image
          alt=""
          class="h-full w-full object-contain"
          [src]="value"
          (error)="Image.src = '/assets/images/default/broken.png'" />
      </button>
      <app-button
        theme="tint-error"
        class="absolute top-1 right-1"
        styleClass="flex items-center justify-center !h-4 !w-4 !rounded-full !px-0"
        (click)="removeImage()">
        <ic-close-outline class="inline-block h-3 w-3" />
      </app-button>
    </div>
  } @else {
    <div
      #UploadBox
      class="group h-full w-full">
      <button
        type="button"
        class="bg-bg-surface-low group-[.ondrag]:bg-bg-tint-brand border-line-default group-[.ondrag]:border-line-brand h-full w-full rounded-lg border border-dashed transition"
        [class]="boxStyleClass"
        [ngClass]="{
          'border-line-error! bg-bg-tint-error!':
            (pickImageError || error) && !UploadBox.classList.contains('ondrag'),
        }"
        (dragover)="handleDragoverAvatar($event, UploadBox)"
        (dragleave)="UploadBox.classList.remove('ondrag')"
        (drop)="handleDropAvatar($event)"
        (click)="handleSelectAvatar()">
        <ic-camera-outline
          class="text-icon-subtle group-[.ondrag]:text-text-brand inline-block h-6 w-6 transition"
          [ngClass]="{ 'text-text-error!': pickImageError }" />
        @if (label) {
          <p class="text-text-subtler text-[10px]">{{ label }}</p>
        }
      </button>
    </div>
  }
</div>
